import styled from 'styled-components';

export const MainContainer = styled.div`
  .ant-tabs-nav {
    padding-left: 0;
  }

  .ant-table-tbody > .ant-table-expanded-row > td {
    padding: 0;
  }
`;

export const TabContentWrapper = styled.div`
  width: 100%;
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    margin-bottom: 14px;
  }
`;
